<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title">{{ values?.titleKey | translate }}</h2>
  <sis-modal-close-button />
</div>
<div class="modal-body">
  @if (values?.messageKey) {
    <p>{{ values?.messageKey | translate }}</p>
  }
  @if (values?.validationErrors?.length > 0) {
    <ul>
      @for (error of values?.validationErrors; track error) {
        <li>
          {{ error.messageKey | translate: error.attributes }}{{ error.entityKey ? ":" : "" }}
          @if (error.entityKey) {
            {{ "ENTITY_NAMES." + error.entityKey | translate }}
            @if (error.fieldKeys?.length > 0) {
              &gt;
            }
            @for (fieldKey of error.fieldKeys; track fieldKey; let last = $last) {
              {{ "FIELD_NAMES." + fieldKey | translate }}
              @if (!last) {
                &gt;
              }
            }
          }
        </li>
      }
    </ul>
  }
</div>
<div class="modal-footer">
  <sis-button (clicked)="modal.dismiss()">{{ "COMMON.CLOSE_ERROR" | translate }}</sis-button>
</div>
